import { apiWrapper, apiCancel } from "../../wrapper";

export const initial = "PetaJabatan";
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL;
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE;
const outputType = "json";

export const masterRegion = "Master/Region/list/";
export const masterWorkUnit = "Master/WorkUnit/list/";

export const PetaJabatanCreatePeriod = "Kepegawaian/PetaJabatan/createPeriod/";
export const PetaJabatanListPeriod = "Kepegawaian/PetaJabatan/listPeriod/";

export const PetaJabatanCreate = "Kepegawaian/PetaJabatan/create/";
export const PetaJabatanList = "Kepegawaian/PetaJabatan/list/";

export const PetaJabatanDetail = "Kepegawaian/PetaJabatan/detail/";
export const PetaJabatanUpdate = "Kepegawaian/PetaJabatan/update/";
export const PetaJabatanInactive = "Kepegawaian/PetaJabatan/inactive/";
export const PetaJabatanActive = "Kepegawaian/PetaJabatan/active/";
export const PetaJabatanExport = "Kepegawaian/PetaJabatan/export/";
export const PetaJabatanExportRekap = "Kepegawaian/PetaJabatan/exportRekap/";
export const PetaJabatanChart = "Kepegawaian/PetaJabatan/chart/";
export const PetaJabatanHirarki = "Kepegawaian/PetaJabatan/unitHirarki/";
export const PetaJabatanHirarkiJabatan =
  "Kepegawaian/PetaJabatan/unitHirarkiJabatan/";

export const JabatanList = "Kepegawaian/PetaJabatan/positionList/";
export const EmployeeList = "Kepegawaian/PetaJabatan/employeeList/";
export const workUnitList = "Kepegawaian/PetaJabatan/workUnitList/";

export const PetaJabatanUpdateKP = "Kepegawaian/PetaJabatan/updateKP/";
export const PetaJabatanDetailKP = "Kepegawaian/PetaJabatan/detailKP/";
export const PetaJabatanNewExport =
  "Kepegawaian/PetaJabatan/exportPetaJabatanNew/";

export const PetaJabatanlistEmployee = "Kepegawaian/PetaJabatan/listEmployee/";
export const treeHirarki = "Kepegawaian/PetaJabatan/treeHirarki/";
export const getInfoUnor = "Kepegawaian/PetaJabatan/get_info_unor/";
export const getInfoJabatan = "Kepegawaian/PetaJabatan/get_info_jabatan/";
export const ListEmployee = "Kepegawaian/PetaJabatan/get_info_pegawai/";
export const getInfoResume = "Kepegawaian/PetaJabatan/get_info_resume/";

//tambahan 
export const exportDataNewPetajabatan = "Kepegawaian/PetaJabatan/exportDataNewPetajabatan/"
export const createInfoJabatan = "Kepegawaian/PetaJabatan/createInfoJabatan/"
export const detailInfoJabatan = "Kepegawaian/PetaJabatan/detailInfoJabatan/"
export const createInfoUnor = "Kepegawaian/PetaJabatan/createInfoUnor/"
export const detailInfoUnor = "Kepegawaian/PetaJabatan/detailInfoUnor/"
export const exportTemplatePetaJabatan = "Kepegawaian/PetaJabatan/exportTemplatePetaJabatan/"
export const importDataPetaJabatan = "Kepegawaian/PetaJabatan/importDataPetaJabatan/"
export const checkmutasipegawai = "Kepegawaian/PetaJabatan/checkmutasipegawai/"
//export const cancelToken = () => apiCancel
export const cancelToken = () => {
  return apiCancel();
};
export const apiRequest = async (
  method,
  route,
  data = { params: null, body: null, cancelToken: null },
  needToken = true
) => {
  if (needToken) {
    const thisTime = Math.floor(Date.now() / 1000);
    const expire = localStorage.getItem(initial + "accessExpired");
    if (expire < thisTime) {
      await apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        "post",
        "auth/getAccessToken/",
        data
      )
        .then((result) => {
          localStorage.setItem(
            initial + "accessToken",
            result.response.access_token
          );
          return apiWrapper(
            baseUrl,
            initial,
            appCode,
            outputType,
            method,
            route,
            data
          );
        })
        .catch((result) => {
          return Promise.reject("Tidak dapat mengambil accessToken");
        });
    } else {
      return apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        method,
        route,
        data
      );
    }
  }
  return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data);
};
